import { ElementType } from "react";
import { twMerge } from "tailwind-merge";
import { getSanitizedHtml } from "../../utils";

interface HtmlContentProps {
    html: string;
    className?: string;
    as?: ElementType;
}

const HtmlContent = (props: HtmlContentProps) => {
    const { html, className, as: Tag = "span" } = props;

    return (
        <Tag
            className={twMerge(
                "[&_a]:text-[#06c] [&_a]:underline",
                className
            )}
            dangerouslySetInnerHTML={{ __html: getSanitizedHtml(html) }}
        />
    );
};

export default HtmlContent;
